import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import {
    Overlay,
    OverlayRef,
    PositionStrategy
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[appTooltipOverlay]',
    standalone: true
})
export class HoverOverlayDirective implements OnDestroy {

  @Input('appTooltipOverlay') set hoverOverlay(value: { template: TemplateRef<any>, context: any } | null) {
    if (value){
      this.tooltipTemplate = value.template;
      this.context = value.context;
      this.disableOverlay = false;
    }
    else {
      this.tooltipTemplate = null;
      this.context = null;
      this.disableOverlay = true;
    }
  }

private tooltipTemplate!: TemplateRef<any> | null;
private context: any;
  private disableOverlay = false;

private overlayRef: OverlayRef | null = null;
private readonly destroy$ = new Subject<void>();
private readonly hover$ = new Subject<boolean>();

@HostListener('mouseenter') onMouseEnter() { this.hover$.next(true); }
@HostListener('mouseleave') onMouseLeave() { this.hover$.next(false); }

constructor(private readonly overlay: Overlay, private readonly elementRef: ElementRef, private readonly viewContainerRef: ViewContainerRef) {
    this.hover$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(show => this.dispatchHoverAction(show));
}
    
  private dispatchHoverAction(show: boolean): void {
    const action = show ? this.openOverlay : this.closeOverlay;
    action.call(this);
  }

  private openOverlay() {
    if (this.overlayRef || !this.tooltipTemplate || this.disableOverlay) {
      return;
    }
    const positionStrategy: PositionStrategy = this.overlay
        .position()
        .flexibleConnectedTo(this.elementRef)
        .withPositions([{
                originX: 'center',
                originY: 'bottom',
                overlayX: 'center',
                overlayY: 'top',
                offsetY: 8
        }]);
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: false,
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });

        const tooltipPortal = new TemplatePortal(
            this.tooltipTemplate,
            this.viewContainerRef,
            { $implicit: this.context }
        );
        this.overlayRef.attach(tooltipPortal);
    }

private closeOverlay() {
    if (this.overlayRef) {
        this.overlayRef.dispose();
        this.overlayRef = null;
    }
}

ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.closeOverlay();
}
}
